// extracted by mini-css-extract-plugin
export default {"container":"GOZoVXlAJ6M9y5Pxgkd0","divider":"sXrFoOGn5yD1TNwd_GQH"};